import { Injectable, ViewContainerRef } from '@angular/core';
import { AlertController, LoadingController, ModalController, ToastController } from '@ionic/angular';
import { DefaultErrorModalComponent } from '@monorepo/ui';
import { LoaderOverlayComponent, MOBILE_SCREEN_UTILS } from '@monorepo/ui';
import { TranslateService } from '@ngx-translate/core';

// [Anubhav] we can name AppNotification, this service can handle following things at "App level"
// 1. Toast Notification https://ionicframework.com/docs/v4/api/toast
// 2. Model Norification https://ionicframework.com/docs/v4/api/modal
// 3. Progress Bar https://ionicframework.com/docs/v4/api/progress-bar
// 4. Loading https://ionicframework.com/docs/v4/api/loading
// Others application can use this service
type TERROR_MODAL_OPTIONS = {
  dismissExistingModal?: boolean;
  errorText?: string;
};
@Injectable({ providedIn: 'root' })
export class AppNotificationUtilClass {
  isMobileScreen = false;

  constructor(
    private loadingController: LoadingController,
    private toastController: ToastController,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private translateService: TranslateService,
  ) {
    this.isMobileScreen = MOBILE_SCREEN_UTILS.isMobileScreen();
  }

  async presentLoading(message?: string, duration?: number) {
    const loading = await this.loadingController.create({
      message: message || this.translateService.instant('common_components.please_wait'),
      backdropDismiss: false,
      keyboardClose: false,
      ...(duration && { duration: duration }),
    });
    await loading.present();
    return loading;
  }

  async dismissLoadingV2(loader: HTMLIonLoadingElement) {
    return await loader.dismiss();
  }

  presentLoaderOverlay(viewContainerRef: ViewContainerRef) {
    viewContainerRef.clear();
    const loaderComponent = viewContainerRef.createComponent(LoaderOverlayComponent);
    viewContainerRef.insert(loaderComponent.hostView);
  }

  dismissLoaderOverlay(viewContainerRef: ViewContainerRef) {
    viewContainerRef.remove();
  }

  async presentToast(header: string, message?: string, color: string = 'dark') {
    const toast = await this.toastController.create({
      header,
      message,
      color: color,
      position: 'top',
      duration: 5000,
      cssClass: 'toast',
      buttons: [
        {
          text: this.translateService.instant('multi_select.Close'),
          role: 'cancel',
          handler: () => {
            console.log('Close clicked');
          },
        },
      ],
    });
    toast.present();
  }

  async showPopup(
    title: string,
    message: string,
    buttons = [
      {
        text: 'Ok',
      },
    ],
  ) {
    const alert = await this.alertCtrl.create({
      header: title,
      subHeader: message,
      buttons: buttons,
    });
    alert.present();
  }

  async openDefaultErrorModal(options?: TERROR_MODAL_OPTIONS) {
    if (options?.dismissExistingModal) this.modalCtrl.dismiss();
    const errorModal = await this.modalCtrl.create({
      component: DefaultErrorModalComponent,
      cssClass: 'm-modal__default-error-modal',
      componentProps: {
        errorTxt: options?.errorText,
      },
    });

    await errorModal.present();
  }

  async presentToastMM(header: string, message?: string) {
    const toast = await this.toastController.create({
      header: this.translateService.instant(header),
      message,
      color: 'dark',
      position: this.isMobileScreen ? 'top' : 'bottom',
      duration: 3000,
      cssClass: 'm-toast__not-authorized',
      buttons: [
        {
          text: this.translateService.instant('multi_select.Close'),
          role: 'cancel',
          handler: () => {
            console.log('Close clicked');
          },
        },
      ],
    });
    toast.present();
  }
}
